/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamClassStudentDropdown200,
  GetApiV1ExamClassStudentDropdown400,
  GetApiV1ExamClassStudentDropdown401,
  GetApiV1ExamClassStudentDropdown500,
  GetApiV1ExamClassStudentDropdownQueryParams,
  GetApiV1ExamClassStudentDropdownQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamClassStudentDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ExamClassStudentDropdownQueryParamsSchema = z.object({
  courseId: z.optional(z.coerce.number().int()),
  companyId: z.optional(z.coerce.number().int()),
  mainOnly: z.boolean().default(false),
  monographOnly: z.boolean().default(false),
}) as unknown as ToZod<GetApiV1ExamClassStudentDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamClassStudentDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamClassStudentDropdown200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamClassStudentDropdown400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamClassStudentDropdown400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamClassStudentDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamClassStudentDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamClassStudentDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamClassStudentDropdown500>;

export const getApiV1ExamClassStudentDropdownQueryResponseSchema = z.lazy(
  () => getApiV1ExamClassStudentDropdown200Schema,
) as unknown as ToZod<GetApiV1ExamClassStudentDropdownQueryResponse>;
